import { render, staticRenderFns } from "./im-static-list-message.vue?vue&type=template&id=4f0426ad&scoped=true"
import script from "./im-static-list-message.vue?vue&type=script&lang=js"
export * from "./im-static-list-message.vue?vue&type=script&lang=js"
import style0 from "./im-static-list-message.vue?vue&type=style&index=0&id=4f0426ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0426ad",
  null
  
)

export default component.exports